import React, { useState, useEffect } from "react";
import { Popover } from "antd";
import styles from "./EllipsisText.module.scss";

interface EllipsisTextProps {
  text: string;
  maxVisibleTextLength: number;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  maxVisibleTextLength,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [showPopover, setShowPopover] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = () => {
    if (isMobile && text.length > 30) {
      setShowPopover(!showPopover);
    }
  };

  const popoverContent = <div>{text}</div>;

  return isMobile && text?.length > maxVisibleTextLength ? (
    <Popover
      content={popoverContent}
      visible={showPopover}
      trigger="click"
      onVisibleChange={(visible) => setShowPopover(visible)}
    >
      <div className={styles.ellipsis} onClick={handleClick}>
        {text}
      </div>
    </Popover>
  ) : (
    <div
      className={styles.ellipsis}
      title={text?.length > maxVisibleTextLength ? text : undefined}
    >
      {text}
    </div>
  );
};

export default EllipsisText;
